import { BaseExpenseFormGroup } from '../base-expense-edit.form';

export class OtherExpenseFormGroup extends BaseExpenseFormGroup<{}> {
    constructor() {
        super({});
    }
}
